import posthog from "posthog-js";

export const CONSENT_KEY = "plays_cookie_consent";
export const CONSENT_EVENT = "plays-consent-change";
export type Consent = "accepted" | "rejected" | null;

let initialized = false;

export const getConsent = (): Consent => {
  const v = localStorage.getItem(CONSENT_KEY);
  return v === "accepted" || v === "rejected" ? v : null;
};

export const initAnalytics = () => {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;
  if (initialized || !key || !host) return;
  posthog.init(key, {
    api_host: host,
    capture_pageview: "history_change",
    persistence: "localStorage+cookie",
    autocapture: true,
  });
  initialized = true;
};

export const setConsent = (value: Exclude<Consent, null>) => {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "accepted") {
    initAnalytics();
    if (initialized) posthog.opt_in_capturing();
  } else if (initialized) {
    posthog.opt_out_capturing();
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
};

export const resetConsent = () => {
  localStorage.removeItem(CONSENT_KEY);
  if (initialized) posthog.opt_out_capturing();
  window.dispatchEvent(new Event(CONSENT_EVENT));
};
